import axios from 'axios';
import store from '../store';
import moment from 'moment';
import izitoast from './toast';

export const API = axios.create({
	baseURL:process.env.VUE_APP_BASE_URL_API
});



API.interceptors.response.use((response) => {
		return response
	}, 
	(error) => {
		const status = error.response.status;
		/*const CancelToken = API.CancelToken;
		const source = CancelToken.source();*/
		if(store.getters.getApiKey!==null){
			if (status == 401 || status == 403) {
				//source.cancel();
				izitoast.error({
					message:'Session expired',
					icon:'ti-face-sad'
					//position:'topRight'
				});
				console.log(error.response)
				store.dispatch('logout');
			}
		}
		return Promise.reject(error);
})

API.interceptors.request.use (
	function (config) {
		const api_key = store.getters.getApiKey;
		if (api_key!==null && store.getters.loginExpire>moment().format('YYYY-MM-DD HH:mm:ss')) 
			config.headers.Authorization = `Bearer ${api_key}`;
		else
			delete config.headers.Authorization
		return config;
	},
	function (error) {
		return Promise.reject (error);
	}
);

export default API;